import React from 'react';
import { View, StyleSheet, FlatList, RefreshControl } from 'react-native';
import { connect } from 'react-redux';

import Colors from '../../constants/Colors';
import UserCard from "../../components/user/UserCard";
import RankingListComponent from "./RankingListComponent";

import get from "../../api/methods/get";
import {GET_RANKING} from "../../api/userEndpoints";
import NavBar from "../../components/NavBar";
import {SpinnerControl} from "../../components";

class RankingScreen extends React.Component {

	state = {
		rankingData: null,
		userPosition: 0,

		isFetching: false,
	}

	fetchRankingData = async () => {
		if (this.state.isFetching) return;
		this.setState({ isFetching: true });

		try {
			const result = await get(GET_RANKING);
			const json = await result.json();
			this.setState({ rankingData: json.data.Items });
		} catch (e) {

		}

		this.setState({ isFetching: false });
	}

	componentDidMount() {
		this.fetchRankingData();
	}

	render() {
        return(
            <NavBar title={"Ranking"}>

				<View style={{ width: 600 }}>
					<UserCard />

					<SpinnerControl
						isFetching={this.state.isFetching}
						text={"Carregando ranking!"}
					/>

					<FlatList
						data={this.state.rankingData}
						renderItem={({item, index}) => {
							return <RankingListComponent
								rankingPosition={index + 1}
								userName={item.userName}
								userPoints={item.points}
							/>
						}}
						keyExtractor={(item) => item.PK.toString()}
						refreshControl={
							<RefreshControl
								refreshing={this.state.isFetching}
								onRefresh={this.fetchRankingData}
								colors={[Colors.spinnerColor]}
								title={'Carregando Ranking!'}
							/>
						}
					/>
				</View>
            </NavBar>
        )
    }
}

const mapStateToProps = state => {
    return {
		userName: state.user.userName,
		userId: state.user.userId,
		userPoints: state.user.points,
    }
};

export default connect(mapStateToProps)(RankingScreen);
